import BoldText from "@base/BoldText";
import Container from "@base/Container";
import PressableBase from "@base/PressableBase";
import RegularText from "@base/RegularText";
import Row from "@base/Row";
import AvatarBase from "@components/avatar/AvatarBase";
import { Header } from "@components/header/Header";
import SeedHistoryList from "@components/history/SeedHistoryList";
import Icon from "@components/icons";
import ScreenWrapper from "@components/wrapper/ScreenWrapper";
import { OAuthService } from "@core/services/oauth/OAuthService";
import { HeaderType } from "@custom-types/HeaderType";
import { NavigationType } from "@custom-types/NavigationType";
import i18n from "@i18n/i18n";
import { LoginNavigatorScreens } from "@navigation/LoginNavigator";
import { Route } from "@react-navigation/native";
import { colors, settings } from "@styles/globalStyles";
import React, { Component } from "react";
import { SafeAreaView, ScrollView, StyleSheet, View } from "react-native";
import Initializer from "../initializer/Initializer";
import { AccessTokenRequest } from "expo-auth-session";
import SemiBoldText from "@base/SemiBold";

interface Props {
    navigation: NavigationType;
    route: Route<string, { userData: any }>;
}

interface State {
    userData: any;
}

const { t } = i18n;

export default class UserOAuthScreen extends Component<Props, State> {
    oAuthService: OAuthService;

    constructor(props: Props) {
        super(props);
        this.onPressCreate = this.onPressCreate.bind(this);
        this.onPressImport = this.onPressImport.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.redirectToCreateAccount = this.redirectToCreateAccount.bind(this);
        this.state = {
            userData: null,
        };
        this.oAuthService = OAuthService.getInstance();
    }

    componentDidMount(): void {
        this.init();
    }

    async init() {
        const userData = this.oAuthService.getClientData();
        this.setState({
            userData,
        });
    }

    onPressImport() {
        this.props.navigation.navigate(LoginNavigatorScreens.ImportSeed.routeName);
    }

    async onPressCreate() {
        await this.oAuthService.newAlias();
        this.props.navigation.navigate(LoginNavigatorScreens.SetProfile.routeName);
    }

    async handleBackButton() {
        await this.oAuthService.signout();
        Initializer.redirect(this.props.navigation);
    }

    async redirectToCreateAccount() {
        await this.oAuthService.newAlias();
        this.props.navigation.navigate(LoginNavigatorScreens.SetProfile.routeName, {
            handleBackButton: true,
        });
    }

    render() {
        return (
            <ScreenWrapper>
                <Header
                    type={HeaderType.Light}
                    {...this.props}
                    leftBtn={{
                        onPress: () => {
                            this.handleBackButton();
                        },
                        icon: "arrow-left",
                        size: 24,
                    }}
                />
                {this.state.userData && (
                    <ScrollView style={{ height: 200 }}>
                        <Container style={styles.container}>
                            <View style={{ flex: 1, paddingTop: 30 }}>
                                <AvatarBase
                                    size={100}
                                    uri={this.state.userData?.avatar || ""}
                                    alias={this.state.userData?.name}
                                ></AvatarBase>

                                <View style={{ paddingTop: 30 }}>
                                    <BoldText align="center" fontSize={18}>
                                        {this.state.userData?.email}
                                    </BoldText>
                                </View>

                                <View style={{ paddingTop: 25 }}>
                                    <View style={styles.buttonsWrapper}>
                                        <PressableBase onPress={this.onPressCreate} vibrate={true}>
                                            <Row style={[styles.button, { backgroundColor: colors.secondary }]}>
                                                <Icon
                                                    style={{ paddingLeft: 5 }}
                                                    size={20}
                                                    color={colors.white}
                                                    name="person-plus"
                                                ></Icon>
                                                <View style={{ flex: 1 }}>
                                                    <RegularText fontSize={17} align="center" color={colors.white}>
                                                        {t("create")}{" "}
                                                        <SemiBoldText color={colors.white}>
                                                            {t("new_user")}
                                                        </SemiBoldText>
                                                    </RegularText>
                                                </View>
                                            </Row>
                                        </PressableBase>
                                        <PressableBase onPress={this.onPressImport} vibrate={true}>
                                            <Row style={[styles.button, { backgroundColor: colors.secondary }]}>
                                                <Icon
                                                    style={{ paddingLeft: 5 }}
                                                    size={20}
                                                    color={colors.white}
                                                    name="person-check"
                                                ></Icon>
                                                <View style={{ flex: 1 }}>
                                                    <RegularText fontSize={17} align="center" color={colors.white}>
                                                        {t("import")}{" "}
                                                        <SemiBoldText color={colors.white}>{t("account")}</SemiBoldText>
                                                    </RegularText>
                                                </View>
                                            </Row>
                                        </PressableBase>
                                    </View>
                                    <View style={{ width: "100%" }}>
                                        <View>
                                            <SeedHistoryList
                                                redirectToCreateAccount={this.redirectToCreateAccount}
                                                listHeader={
                                                    <Row
                                                        style={{
                                                            justifyContent: "flex-start",
                                                            alignItems: "center",
                                                            marginBottom: 10,
                                                            paddingTop: 30,
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                backgroundColor: colors.complementary,
                                                                borderRadius: 15,
                                                                height: 30,
                                                                width: 30,
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                alignContent: "center",
                                                            }}
                                                        >
                                                            <Icon
                                                                size={18}
                                                                color={colors.white}
                                                                name={"person-list"}
                                                            ></Icon>
                                                        </View>
                                                        <SafeAreaView style={{ flex: 1 }}>
                                                            <RegularText align="justify" style={{ paddingLeft: 8 }}>
                                                                {t("use_account_associated")}{" "}
                                                                {this.state.userData?.email}
                                                            </RegularText>
                                                        </SafeAreaView>
                                                    </Row>
                                                }
                                                navigation={this.props.navigation}
                                            />
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Container>
                    </ScrollView>
                )}
            </ScreenWrapper>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,

        alignItems: "center",
        alignContent: "center",
    },
    buttonsWrapper: {
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 0,
    },
    button: {
        minWidth: 280,
        padding: 12,
        alignItems: "center",
        textAlignVertical: "center",
        alignSelf: "center",
        textAlign: "center",
        borderRadius: settings.mainButtonsRadius || 25,
        overflow: "hidden",
        marginVertical: 5,
    },
});
